<script setup lang="ts">
import { PropType, computed } from 'vue'
import { AlertColour } from '../../types/enums'
import type { StatusAlert } from './../../types'
import { getCurrentCulture } from './../../utilities/culture-helper'

const props = defineProps({
  statusAlert: {
    type: Object as PropType<StatusAlert>,
    required: true,
  },
})

const { cultureShortCode } = getCurrentCulture()
const alertThemeClass = computed<string>(() => {
  switch (props.statusAlert.colour) {
    default:
      return ''
    case AlertColour.Red:
      return 'note--danger'
    case AlertColour.Amber:
      return 'note--alert'
    case AlertColour.Green:
      return 'note--info'
  }
})
</script>

<template>
  <div class="p-b-x16">
    <div class="cws">
      <div
        v-if="statusAlert.message[cultureShortCode]"
        :class="['note', alertThemeClass]"
      >
        <div class="note__icon">
          <svg><use xlink:href="#svg-alert"></use></svg>
        </div>
        <div
          class="note__text"
          v-html="statusAlert.message[cultureShortCode]"
        ></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
